class StickyAnnouncementBar extends HTMLElement {
    connectedCallback() {
        this.section = this.closest(".shopify-section") || this;
        this.section.classList.add("announcement-bar-section--sticky");

        this.resizeObserver = new ResizeObserver(() => this.publishHeight());
        this.resizeObserver.observe(this);
        this.publishHeight();
    }

    disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.section.classList.remove("announcement-bar-section--sticky");
        document.documentElement.style.removeProperty("--announcement-bar-height");
    }

    /**
     * Publishes the rendered height as a global CSS variable so other sticky
     * elements (mega menu, sticky header) can offset themselves and stack
     * below the bar instead of overlapping it. Resolves to 0 when the bar is
     * hidden (e.g. "hide on mobile") or when the setting is disabled.
     * @returns {void}
     */
    publishHeight() {
        document.documentElement.style.setProperty("--announcement-bar-height", `${this.offsetHeight}px`);
    }
}

customElements.define("sticky-announcement-bar", StickyAnnouncementBar);
